import { render, staticRenderFns } from "./BanUser.vue?vue&type=template&id=336c194a"
import script from "./BanUser.vue?vue&type=script&lang=js"
export * from "./BanUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports